import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-skipped-user',
  standalone: false,
  templateUrl: './skipped-user.component.html',
  styleUrl: './skipped-user.component.scss'
})
export class SkippedUserComponent {
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<SkippedUserComponent>);
  positivePersonas: any[] = [];
  negativePersonas: any[] = [];

  changeSkipped(persona: any, match: boolean) {
    if (match) {
      this.positivePersonas.push(persona);
    } else {
      this.negativePersonas.push(persona);
    }
    this.data.personas = this.data.personas.filter((p: any) => p !== persona)
  }

  done() {
    this.dialogRef.close({ positive: this.positivePersonas, negative: this.negativePersonas, skipped: this.data.personas })
  }
}
